import classes from './reward-summary.module.css';

type Rewards = { experience: number; coins: number };
type Props = { rewards: Rewards; earned?: Rewards; maximum?: boolean; only?: 'experience' | 'coins' };

export const RewardSummary = ({ rewards, earned, maximum = false, only }: Props) => (
  <span className={classes.root}>
    {only !== 'coins' && (
      <span
        role="group"
        aria-label={
          maximum
            ? `До ${rewards.experience} XP`
            : earned
              ? `Получено ${earned.experience} из ${rewards.experience} XP`
              : `Полученный опыт неизвестен. Всего ${rewards.experience} XP`
        }
      >
        <span className={classes.label}>XP</span>
        <strong
          data-complete={(earned && rewards.experience > 0 && earned.experience >= rewards.experience) || undefined}
        >
          {maximum ? (
            'до'
          ) : (
            <>
              <span className={classes.current}>{earned?.experience.toLocaleString('ru-RU') ?? '—'}</span>{' '}
              <span className={classes.separator}>/</span>
            </>
          )}{' '}
          {rewards.experience.toLocaleString('ru-RU')}
        </strong>
      </span>
    )}
    {only !== 'experience' && (rewards.coins > 0 || (earned?.coins ?? 0) > 0) && (
      <span
        role="group"
        aria-label={
          maximum
            ? `До ${rewards.coins} узнабаксов`
            : earned
              ? `Получено ${earned.coins} из ${rewards.coins} узнабаксов`
              : `Полученные узнабаксы неизвестны. Всего ${rewards.coins}`
        }
      >
        <img src="/uznabuck.webp" alt="" aria-hidden="true" />
        <strong data-complete={(earned && rewards.coins > 0 && earned.coins >= rewards.coins) || undefined}>
          {maximum ? (
            'до'
          ) : (
            <>
              <span className={classes.current}>{earned?.coins.toLocaleString('ru-RU') ?? '—'}</span>{' '}
              <span className={classes.separator}>/</span>
            </>
          )}{' '}
          {rewards.coins.toLocaleString('ru-RU')}
        </strong>
      </span>
    )}
  </span>
);
